export const NAMES = {
  TAG_NAME: "ab-specification-picker",
  CLASS_ROOT: "ab-specification-picker",
  CLASS_SELECT_WRAPPER: "ab-specification-picker__select-wrapper",
};

